import { IS_DEV, IS_PROD } from '../constants/app.const';

export function shouldUseNewRelic() {
  return !!((IS_PROD || IS_DEV) && window?.newrelic);
}
